import Modal from "react-bootstrap/Modal";

function ResendActivationModal({ modalShow, phone, handleSend, onHide }) {
  return (
    phone && (
      <Modal
        show={modalShow}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            CONFIRMACIÓN
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            SE ENVIARÁ CÓDIGO DE ACTIVACIÓN AL CELULAR <strong>{phone}</strong>.
          </p>
          <p>¿DESEA CONTINUAR?</p>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" onClick={onHide} className="btn btn-dark">
            CANCELAR
          </button>
          <button
            type="button"
            onClick={handleSend}
            className="btn btn-success"
          >
            CONTINUAR
          </button>
        </Modal.Footer>
      </Modal>
    )
  );
}

export default ResendActivationModal;
